import { StatementPart, TemplatePart } from "../types";
import { extractStatementParts } from "../utils/extractHelpers";

export type StatementExtract = {
  statementPart: StatementPart;
  parentPart: TemplatePart;
};

export function extractStatementsWithinParts(
  parts: TemplatePart[]
): StatementExtract[] {
  return parts
    .filter(it => it.type !== "markdown")
    .reduce(
      (acc, part) =>
        acc.concat(
          extractStatementParts(part.original).map(it => ({
            statementPart: it,
            parentPart: part
          }))
        ),
      [] as StatementExtract[]
    );
}
